import { UpdateAlternativeLabelsCommandV1 } from '@Alternatives/AlternativesLists/Domain/commands-core';
import AlternativesListsCommands from '@Alternatives/AlternativesLists/Domain/commands-vue-component';
import AlternativesListsQueries from '@Alternatives/AlternativesLists/Domain/queries-vue-component';
import { AlternativesListReadModel } from '@Alternatives/AlternativesLists/Domain/readmodels';
import { ICommandBase } from '@Alternatives/cqrs';
import PortfolioOrDecisionNavigation from "@common/Components/PortfolioOrDecisionNavigation.vue";
import { Component, mixins } from 'vue-facing-decorator';

@Component({
    components: {
        PortfolioOrDecisionNavigation
    }
})
export default class AlternativeLabelsEditorPage extends mixins(AlternativesListsQueries, AlternativesListsCommands)
{
    get workspaceId(): number { return Number(this.$route?.params?.workspaceId ?? 0); }
    get projectId(): number { return Number(this.$route?.params?.projectId ?? 0); }

    rm: AlternativesListReadModel | null = null;

    handleUpdateAlternativeLabelsCommand()
    {
        this.invokeUpdateAlternativeLabelsCommandV1(this.workspaceId, this.rm.Id, this.rm.AlternativeLabel, this.rm.AlternativesLabel);
    }


    mounted()
    {
        document.title = "Labels | TransparentChoice";
        this.runAlternativesListByProjectIdQueryV1(this.workspaceId, this.projectId);
    }


    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "AlternativesListReadModel")
        {
            this.rm = model as AlternativesListReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string, result: any)
    {
        if (UpdateAlternativeLabelsCommandV1.matchType(cmd))
        {
            alert("saved");
        }
    }

    onCommandFailed(status: any)
    {
        //if (UpdateRequestPageCommandV1.matchType(status.Command))
        //{
        //    for (const error of status.ValidationErrors)
        //    {
        //        alert(error.Error);
        //    }
        //}
    }
}